module.exports = __webpack_public_path__ + "static/media/black-arrow.74093cd8.svg";